import { gql } from '@apollo/client';

const Fragments = {
  offerCancelled: gql`
    fragment offerCancelled on OfferCancelledStates {
      checkExpiredFolders
      offerReasonIdForExpiredFolder
      offerReasonCodeForExpiredFolder
      cancelledStateId
      cancelledStateCode
      offerCancelledConditions {
        ...offerCancelledConditions
      }
    }
  `,
  conditions: gql`
    fragment offerCancelledConditions on OfferCancelledCondition {
      documentTypeId
      documentTypeCode
      documentTypeName
      stateId
      stateCode
      stateName
      normalExpiryPeriod
      extendedExpiryPeriod
      referenceDate
      reasonId
      reasonCode
      reasonName
    }
  `
};

export default Fragments;
